var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 26,
    viewBox: "0 0 56 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-192.261,645l-13.8,12.9,13.8,13.1h42.2V645Zm23.642,20-4.956-4.863-4.946,4.853-2.179-2.128,4.946-4.853-4.956-4.863,2.189-2.147,4.956,4.863,4.956-4.863,2.169,2.138L-171.386,658l4.956,4.853Z",
    transform: "translate(206.06 -645)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.7df1fd083445e6bc6eb525f844b4395a.svg";
export { ForwardRef as ReactComponent };